import React, {useRef} from 'react';
import {inject, observer} from "mobx-react";
import Registration from "../Registration";
import './modal.scss';

const ModalRegForm = inject('appStore')(observer(props => {
  const {
    isModalVisible,
    brandName,
    lang,
    langId,
    defaultCountryId,
    defaultCurrencyId,
    defaultPromoCode,
    regFormTitle,
    onCloseModal,
    landingName
  } = props

  const modalRef = useRef();
  const closeBtnRef = useRef();

  const closeModal = (e, ref) => {
    if (e.target === ref.current) {
      onCloseModal(false);
    }
  }

  return (
    isModalVisible
      ?
    <div className={`modal-reg-form modal-reg-form_${lang}`} onClick={(e) => closeModal(e, modalRef)} ref={modalRef}>
      <div className='modal-reg-form__wrapper'>
        <div className='modal-reg-form__close' ref={closeBtnRef} onClick={(e) => closeModal(e, closeBtnRef)} />
        <Registration
          brandName={brandName}
          lang={lang}
          langId={langId}
          defaultCountryId={defaultCountryId}
          defaultCurrencyId={defaultCurrencyId}
          defaultPromoCode={defaultPromoCode}
          regFormTitle={regFormTitle}
          landingName={landingName}
        />
      </div>
    </div>
      : null
  );
}));

export default ModalRegForm;
